import React from 'react'
import { twMerge } from 'tailwind-merge'

import { ReactComponent as PilliotBlancLogo } from '../../assets/pilliot-text-blanc.svg'
import { ReactComponent as IconLogo } from '../../assets/pilliot-logo.svg'
import { ReactComponent as PilliotLogo } from '../../assets/pilliot-text.svg'

// eslint-disable-next-line @typescript-eslint/no-empty-interface
export interface LogoProps {
  className?: string
  variant: 'pilliot-blanc' | 'icon' | 'pilliot'
}

export const Logo: React.FC<LogoProps> = ({ className, variant = 'text' }) => {
  const Comp =
    variant === 'pilliot-blanc' ? PilliotBlancLogo : variant === 'pilliot' ? PilliotLogo : IconLogo
  return <Comp className={twMerge(className)} />
}

Logo.displayName = 'Logo'
